export default function () {
    return {
        restrict: 'E',
        replace: true,
        template: require('../partials-html/accordion.html')
    };
}



// WEBPACK FOOTER //
// ./Client/app/sink/main/partials-js/accordion.js